import { render, staticRenderFns } from "./mailbox.vue?vue&type=template&id=6e4a5542&scoped=true&"
import script from "./mailbox.ts?vue&type=script&lang=ts&"
export * from "./mailbox.ts?vue&type=script&lang=ts&"
import style0 from "./mailbox.scss?vue&type=style&index=0&id=6e4a5542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4a5542",
  null
  
)

export default component.exports